var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",class:{
    'f-input': true,
    'form-control': true,
    'is-valid': _vm.state !== 'invalid',
    'is-invalid': _vm.state === 'invalid',
    'is-small': _vm.small
  },attrs:{"id":_vm.computedID,"aria-invalid":_vm.state === 'invalid',"aria-required":_vm.required ? true : null,"autocomplete":_vm.autocomplete,"disabled":_vm.disabled,"name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"required":_vm.required,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }